import { uploadFile } from '../repositories/RequestRepository'

const useUploadFile = () => {
    const handleUpdateFile = (
        data,
        onUploaded,
        onError,
        additionalInfo,
        fileError,
    ) => {
        return uploadFile(data)
            .then(resp => onUploaded(resp, additionalInfo))
            .catch(resp => onError(resp, fileError))
    }

    return {
        handleUpdateFile,
    }
}

export default useUploadFile
